import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Consultation from "./pages/Consultation";
import PaymentSuccess from "./pages/PaymentSuccess";

const TOAST_OPTIONS = {
    style: {
        background: "#F5F2EA",
        color: "#2C332A",
        border: "1px solid #E3DCC8",
    },
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/consultation" element={<Consultation />} />
                        <Route
                            path="/payment-success"
                            element={<PaymentSuccess />}
                        />
                    </Route>
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" toastOptions={TOAST_OPTIONS} />
        </div>
    );
}

export default App;
